<template>
  <section>
    <!-- AboutUs Hero section -->
    <AboutHeroSection />

    <!-- About Benda Intro Section -->
    <div class="items-stretch lg:flex">
      <div class="w-full overflow-hidden md:flex md:flex-row">
        <div
          class="overflow-hidden md:order-1 xl:flex md:w-1/2 md:h-[640px]"
          data-aos="fade-right"
          data-aos-delay="100"
          data-aos-offset="50"
        >
          <img
            src="@/assets/images/about-us/benda-about-us-banner.png"
            class="self-center object-cover object-right w-full h-full mx-auto xyz-nested"
            xyz="fade small delay-5"
            loading="lazy"
          />
        </div>
        <div
          class="flex items-center justify-start px-4 overflow-hidden md:order-2 xl:py-8 md:w-1/2 md:h-[640px]"
          data-aos="fade-left"
          data-aos-delay="10"
        >
          <div
            class="w-auto py-0 pt-[30px] xl:pt-0 pb-[60px] xl:pb-0 xl:py-4 md:pl-4 lg:pr-6 xl:mx-20"
          >
            <!-- w-[299px]  md:w-[270px] lg:w-[340px] xl:w-[471px] xl:w-[510px] -->
            <h1
              class="text-lg xl:text-[28px] font-OPPO-sans-heavy text-black uppercase xl:tracking-normal tracking-[-2%] leading-[39px] md:leading-[3rem] xl:leading-[32px] text-start"
            >
              {{
                $t("common.benda.about_title", {
                  benda_brand: "Benda ",
                  interpolation: { prefix: "[:", suffix: "]" },
                })
              }}
            </h1>
            <!-- xl:w-[525px]  -->
            <div class="mt-[16px] xl:mt-[22px]">
              <p
                class="text-[15px] md:text-base xl:text-[20px] font-light xl:leading-[normal] font-OPPO-sans-regular"
                v-html="$t('common.benda.about_us_section_1')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Keeway Benda bike section -->
    <section class="relative">
      <img
        src="@/assets/images/about-us/about-us-keeway-benda-mobile-cover.png"
        loading="lazy"
        class="order-1 block object-cover w-full md:hidden bg-secondary"
        alt=""
      />
      <img
        src="@/assets/images/about-us/about-us-keeway-benda-cover.png"
        class="order-1 hidden object-cover w-full md:block bg-secondary"
        alt=""
      />

      <div
        class="xl:-mt-3 py-5 xl:px-4 pt-[30px] xl:pt-[61px] pb-[60px] xl:pb-[54px] order-2 w-full bg-secondary"
      >
        <div
          class="border-b-4 w-[108px] h-1 lg:h-[6px] mx-auto mb-0 xl:mb-[31px] skew-x-[-50deg] border-primary"
        />
        <div
          class="w-full px-4 mt-[16px] xl:mt-[25px] md:mx-auto md:max-w-7xl md:px-16"
        >
          <p
            class="text-[15px] text-center text-white md:text-base xl:mt-[25px] xl:text-[19px] xl:leading-[32px] font-OPPO-sans-regular font-light"
            v-html="
              $t('common.benda.about_us_section_2', {
                benda_brand: 'Benda ',
                keeway_brand: 'Keeway ',
                interpolation: { prefix: '[:', suffix: ']' },
              })
            "
          />
        </div>
      </div>
    </section>

    <!-- About Keeway Group -->
    <div class="items-stretch lg:flex">
      <div class="w-full overflow-hidden md:flex md:flex-row">
        <div
          class="overflow-hidden md:order-1 xl:flex md:w-1/2 md:h-[640px]"
          data-aos="fade-right"
          data-aos-delay="100"
        >
          <img
            src="@/assets/images/about-us/benda-keeway-group.png"
            class="self-center object-cover object-right w-full h-full xyz-nested"
            xyz="fade small delay-5"
            loading="lazy"
          />
        </div>
        <div
          class="flex items-center justify-start px-4 overflow-hidden md:order-2 xl:py-14 md:w-1/2"
          data-aos="fade-left"
          data-aos-delay="100"
        >
          <div
            class="w-auto py-0 pt-[30px] xl:pt-0 pb-[60px] xl:pb-0 xl:py-4 md:pl-4 lg:pr-6 xl:mx-20"
          >
            <h1
              class="text-lg xl:text-[28px] font-OPPO-sans-heavy text-black uppercase xl:tracking-normal tracking-[-2%] leading-[39px] md:leading-[3rem] xl:leading-[32px] text-start"
            >
              {{
                $t("common.keeway_group_title", {
                  keeway_brand: "Keeway ",
                  interpolation: { prefix: "[:", suffix: "]" },
                })
              }}
            </h1>
            <p
              class="text-[15px] md:text-base md:leading-7 mt-[16px] xl:mt-[30px] xl:text-[20px] font-lightext-[#020202] font-OPPO-sans-regular font-light"
              v-html="
                $t('common.benda.about_us_section_3', {
                  benda_brand: 'Benda ',
                  benelli_brand: 'Benelli',
                  morbidelli_brand: 'Morbidelli',
                  mbp_brand: 'MBP',
                  keeway_brand: 'Keeway ',
                  interpolation: { prefix: '[:', suffix: ']' },
                })
              "
            />
          </div>
        </div>
      </div>
    </div>

    <!-- V4 CRUUSE 302 BENDA -->
    <div class="items-stretch lg:flex">
      <div class="flex flex-col w-full overflow-hidden md:flex-row">
        <div
          class="flex items-center justify-start order-2 px-4 overflow-hidden md:order-1 xl:py-8 md:w-1/2 md:h-[520px]"
          data-aos="fade-left"
          data-aos-delay="100"
        >
          <div
            class="w-auto pt-[30px] xl:pt-0 xl:py-4 pb-[60px] xl:pb-0 md:pl-4 lg:pr-6 xl:mx-20"
          >
            <div
              class="border-b-4 w-[108px] h-1 lg:h-[6px] mb-0 xl:mb-[31px] skew-x-[-50deg] border-primary"
            />
            <p
              class="text-[15px] md:text-base mt-[16px] xl:mt-[30px] leading-[24px] xl:leading-[32px] xl:text-[20px] font-lightext-[#020202] font-OPPO-sans-regular font-light"
              v-html="
                $t('common.benda.about_us_section_4', {
                  benda_brand: 'Benda ',
                  keeway_brand: 'Keeway ',
                  interpolation: { prefix: '[:', suffix: ']' },
                })
              "
            />
          </div>
        </div>
        <div
          class="order-1 overflow-hidden md:order-2 md:flex md:w-1/2 md:h-[520px]"
          data-aos="fade-right"
          data-aos-delay="100"
        >
          <!-- <img
            src="@/assets/images/about-us/keeway-benda-v4-cruise-bike-mobile.png"
            class="self-center block object-cover object-right w-full h-full xl:hidden lg:hidden xyz-nested"
            xyz="fade small delay-5"
          > -->
          <img
            src="@/assets/images/about-us/keeway-benda-v4-cruise-bike.png"
            class="self-center object-cover object-right w-full h-full mx-auto xyz-nested"
            xyz="fade small delay-5"
            loading="lazy"
          />
        </div>
      </div>
    </div>

    <!-- Benda Led Light Bike section -->
    <div class="items-stretch lg:flex">
      <div class="flex flex-col w-full overflow-hidden md:flex-row">
        <div
          class="order-1 overflow-hidden xl:flex md:w-1/2 md:md:h-[520px] lg:h-[640px]"
          data-aos="fade-right"
          data-aos-delay="100"
        >
          <img
            src="@/assets/images/about-us/benda-led-light-bike.png"
            class="self-center object-cover object-right w-full h-full mx-auto xyz-nested"
            xyz="fade small delay-5"
            loading="lazy"
          />
        </div>
        <div
          style="background: #191919"
          class="flex items-center justify-start order-2 px-4 overflow-hidden xl:py-8 md:w-1/2 md:md:h-[520px] lg:h-[640px]"
          data-aos="fade-left"
          data-aos-delay="100"
        >
          <div
            class="w-auto pt-[30px] xl:pt-0 pb-[60px] xl:pb-0 py-0 xl:py-4 md:pl-4 lg:pr-6 xl:mx-20"
          >
            <div
              class="border-b-4 w-[108px] skew-x-[-50deg] flex justify-start items-start text-start h-1 lg:h-[6px] mb-0 xl:mb-[31px] border-primary"
            />
            <p
              class="text-[15px] text-white mt-[16px] md:text-base xl:mt-[25px] xl:text-[19px] xl:leading-[32px] font-OPPO-sans-regular font-light"
              v-html="
                $t('common.benda.about_us_section_5', {
                  benda_brand: 'Benda ',
                  keeway_brand: 'Keeway ',
                  interpolation: { prefix: '[:', suffix: ']' },
                })
              "
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Benda V-Twine Bike Revolution section -->
    <div class="items-stretch lg:flex">
      <div class="w-full overflow-hidden md:flex md:flex-row">
        <div
          class="order-2 overflow-hidden xl:flex md:w-1/2 md:md:h-[520px] lg:h-[640px]"
          data-aos="fade-right"
          data-aos-delay="100"
        >
          <img
            src="@/assets/images/about-us/benda-v-twine-revolution-bike.png"
            class="self-center h-[346px] xl:object-cover md:h-full object-right w-full mx-auto xyz-nested"
            xyz="fade small delay-5"
            loading="lazy"
          />
        </div>
        <div
          style="background: #191919"
          class="flex items-center justify-start order-1 px-4 overflow-hidden xl:py-8 md:w-1/2 md:md:h-[520px] lg:h-[640px]"
          data-aos="fade-left"
          data-aos-delay="100"
        >
          <div
            class="w-auto pt-[30px] xl:pt-0 pb-[60px] xl:pb-0 py-0 xl:py-4 md:pl-4 lg:pr-6 xl:mx-20"
          >
            <div
              class="border-b-4 w-[108px] skew-x-[-50deg] flex justify-start items-start text-start h-1 lg:h-[6px] mb-0 xl:mb-[31px] border-primary"
            />
            <p
              class="text-[15px] mt-[16px] xl:mt-[25px] text-white md:text-base xl:text-[19px] xl:leading-[32px] font-OPPO-sans-regular font-light"
              v-html="
                $t('common.benda.about_us_section_6', {
                  benda_brand: 'Benda ',
                  keeway_brand: 'Keeway ',
                  interpolation: { prefix: '[:', suffix: ']' },
                })
              "
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from "vue";
import { useTranslation } from "i18next-vue";

const controls = ref(false);
const { t } = useTranslation();
</script>

<style lang="postcss">
.about-us__history {
  background-image: url("@/assets/images/about-us/italy-bg.jpg");
  background-repeat: no-repeat;
  background-position: bottom center;
  @apply md:bg-cover;

  p {
    text-shadow: 2px 3px 5px rgba(0, 0, 0, 0.5);
  }
}
b {
  font-weight: 800;
}
</style>
